import { AccountCancelIcon } from './AccountCancelIcon';

/**
 * author: Simran
 * id 31CE9FF1-9698-4ED6-8E9B-392840E55DDE
 * name account-cancel
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-cancel.svg
 * tags
 * - Account / User 
 */
export const PersonCancelIcon = AccountCancelIcon;
export default PersonCancelIcon